/* eslint-disable no-param-reassign */
const SCROLLBAR_TRACK_BOTTOM_SPACE = 14;

/**
 * Создание скроллбара и трека для how-to-menu и скроллбара в textarea формы обратной связи
 * @param {HTMLElement} container - прокручиваемый контейнер
 * @param {Object} options - доп настройки
 * @returns {{scrollbar: HTMLElement, scrollbarTrack: HTMLElement}}
 */
function createScrollbar(container, options = {}) {
  const wrapper = document.createElement("div");
  wrapper.className = options.wrapperClass || "custom-scrollbar-wrapper";

  container.parentNode.insertBefore(wrapper, container);
  wrapper.appendChild(container);

  const scrollbarTrack = document.createElement("div");
  scrollbarTrack.className = options.trackClass || "scrollbar-track";

  const scrollbar = document.createElement("div");
  scrollbar.className = options.thumbClass || "scrollbar-thumb";
  wrapper.appendChild(scrollbarTrack);
  wrapper.appendChild(scrollbar);

  return { scrollbar, scrollbarTrack, wrapper };
}

/**
 * Возвращает функцию updateScrollbar
 */
function getUpdateScrollbarHandler(container, scrollbar, scrollbarTrack) {
  return function updateScrollbar() {
    const totalHeight = container.scrollHeight;
    const visibleHeight = container.clientHeight;

    const isScrollable = totalHeight > visibleHeight;

    [scrollbar, scrollbarTrack].forEach(el => el?.classList.toggle("hide", !isScrollable));

    if (isScrollable) {
      const ratio = visibleHeight / totalHeight;
      const thumbHeight = Math.max(20, ratio * visibleHeight);
      scrollbar.style.height = `${thumbHeight - SCROLLBAR_TRACK_BOTTOM_SPACE}px`;

      const { scrollTop } = container;
      const maxScrollTop = totalHeight - visibleHeight;
      const scrollPercent = scrollTop / maxScrollTop;
      const scrollableSpace = visibleHeight - thumbHeight;
      const newTop = scrollPercent * scrollableSpace;

      scrollbar.style.top = `${newTop}px`;
    }
  };
}

/**
 * drag & drop поведение для скроллбара
 */
function setupDragHandler(container, scrollbar) {
  let isDragging = false;
  let startY = 0;
  let startBarTop = 0;

  scrollbar.addEventListener("mousedown", (e) => {
    isDragging = true;
    startY = e.clientY;
    startBarTop = parseFloat(scrollbar.style.top) || 0;
    e.preventDefault();
  });

  document.addEventListener("mousemove", (e) => {
    if (isDragging) {
      const deltaY = e.clientY - startY;
      const visibleHeight = container.clientHeight;
      const totalHeight = container.scrollHeight;
      const thumbHeight = parseFloat(scrollbar.style.height) || 0;
      const maxScrollTop = totalHeight - visibleHeight;

      const scrollableSpace = visibleHeight - thumbHeight;
      let newTop = startBarTop + deltaY;
      newTop = Math.max(0, Math.min(newTop, scrollableSpace));

      scrollbar.style.top = `${newTop}px`;
      container.scrollTop = (newTop / scrollableSpace) * maxScrollTop;
    }
  });

  document.addEventListener("mouseup", () => {
    isDragging = false;
  });
}

export {
  createScrollbar,
  getUpdateScrollbarHandler,
  setupDragHandler,
};